import React from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import CommonDatePicker from "@/Components/Common/CommonDatePicker";
import Select from 'react-select';
import { SITE_ID, SUBDOMAIN } from '../../../assets/meta/meta';
import moment from 'moment';
import MyEditor from "../../../Components/editor/MyEditor";
import { API } from '../../../api/client';
import { Button, Modal, ModalBody, ModalHeader, Nav, NavItem, NavLink } from '@/Components/ui';
import { couponService } from '@/api/services/coupon.service';
import { findMissingRequiredFields, focusFirstMissingField, formatRequiredMessage } from '@/utils/formRequired';
import { dialogService } from "@/utils/dialogService";
import { cn } from '@/lib/utils';
import { COUPON_PERIOD_SECONDS, CouponPeriodUnit, getCouponPeriodLimitMessage, toCouponPeriodSeconds } from './couponPeriod';
import { DEFAULT_UNSAVED_CHANGES_MESSAGE, useUnsavedChangesGuard } from '@/hooks/useUnsavedChangesGuard';
const CouponForm = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const isCopyMode = searchParams.get("copy") === "true";
    const requestedTab = searchParams.get("tab");
    const fileInputRef = React.useRef(null);
    const [packages, setPackages] = React.useState([]);
    const [tickets, setTickets] = React.useState([]);
    const [shoppingCategories, setShoppingCategories] = React.useState([]);
    const [selectedPackageItems, setSelectedPackageItems] = React.useState([]);
    const [selectedTicketItems, setSelectedTicketItems] = React.useState([]);
    const [selectedShoppingCategories, setSelectedShoppingCategories] = React.useState([]);
    const [reservStartDate, setReservStartDate] = React.useState(null);
    const [reservEndDate, setReservEndDate] = React.useState(null);
    const [reservUseMon, setReservUseMon] = React.useState(true);
    const [reservUseTue, setReservUseTue] = React.useState(true);
    const [reservUseWed, setReservUseWed] = React.useState(true);
    const [reservUseThu, setReservUseThu] = React.useState(true);
    const [reservUseFri, setReservUseFri] = React.useState(true);
    const [reservUseSat, setReservUseSat] = React.useState(true);
    const [reservUseSun, setReservUseSun] = React.useState(true);
    const [reservUseHoliday, setReservUseHoliday] = React.useState(true);
    const [boundType, setBoundType] = React.useState("reservation");
    const [couponState, setCouponState] = React.useState("노출중");
    const [title, setTitle] = React.useState("");
    const [type, setType] = React.useState("price");
    const [amount, setAmount] = React.useState("");
    const [image, setImage] = React.useState(null);
    const [prevImage, setPrevImage] = React.useState(null);
    const [minAmount, setMinAmount] = React.useState("");
    const [maxAmount, setMaxAmount] = React.useState("");
    const [period, setPeriod] = React.useState("");
    const [unit, setUnit] = React.useState("years");
    const [isDate, setIsDate] = React.useState(false);
    const [expireDate, setExpireDate] = React.useState(null);
    const [descript, setDescript] = React.useState("");
    const [eventSites, setEventSites] = React.useState([]);
    const [couponBookRules, setCouponBookRules] = React.useState([]);
    const [bookRuleLoading, setBookRuleLoading] = React.useState(false);
    const [editingBookRuleId, setEditingBookRuleId] = React.useState<number | null>(null);
    const [bookStartDate, setBookStartDate] = React.useState(new Date());
    const [bookEndDate, setBookEndDate] = React.useState(new Date());
    const [bookState, setBookState] = React.useState("노출중");
    const [bookStock, setBookStock] = React.useState(1);
    const [bookType, setBookType] = React.useState("event");
    const [bookUsageAmount, setBookUsageAmount] = React.useState(0);
    const [bookUsagePeriod, setBookUsagePeriod] = React.useState(30);
    const [selectedBookSites, setSelectedBookSites] = React.useState([{ value: SITE_ID, label: "현재 사이트" }]);
    const couponId = Number(id || 0);
    const canManageBookRules = couponId !== 0 && !isCopyMode;
    const webBaseUrl = React.useMemo(() => {
        const domain = (window as any).AMZ_ENV.REACT_APP_DOMAIN || "amazingticket.site";
        return `https://${SUBDOMAIN}.${domain}`;
    }, []);
    const currentBookSiteOption = React.useMemo(() => eventSites.find((site) => site.value === SITE_ID) || { value: SITE_ID, label: "현재 사이트" }, [eventSites]);
    const [activeTab, setActiveTab] = React.useState("basic");
    const [bookRuleModalOpen, setBookRuleModalOpen] = React.useState(false);
    const [hasUnsavedChanges, setHasUnsavedChanges] = React.useState(false);
    const [hasUnsavedBookRuleChanges, setHasUnsavedBookRuleChanges] = React.useState(false);
    const markDirty = React.useCallback(() => setHasUnsavedChanges(true), []);
    const markBookRuleDirty = React.useCallback(() => setHasUnsavedBookRuleChanges(true), []);
    const { confirmDiscardChanges } = useUnsavedChangesGuard({
        isDirty: hasUnsavedChanges || hasUnsavedBookRuleChanges,
        confirmNavigation: dialogService.confirm,
    });
    const handleImageFiles = (e) => {
        const files = e.target.files;
        if (files.length !== 0) {
            markDirty();
            setImage(files[0]);
        }
    };
    React.useEffect(() => {
        if (id && id !== '0') {
            API.get(`/coupon/products/${id}/`)
                .then(response => fillStates(response.data, isCopyMode))
                .catch(async (error) => await dialogService.handleAlert(error.message, { force: "error" }));
        }
    }, [id, isCopyMode]);
    React.useEffect(() => {
        if (boundType) {
            const endpoint = boundType === "reservation" ? '/package/items/'
                : boundType === "ticket" ? '/ticket/products/'
                    : '/shop/category/';
            API.get(endpoint)
                .then(response => {
                    let tmp = [];
                    response.data.forEach((item) => {
                        tmp.push({
                            value: item.id,
                            label: boundType === "reservation" ? item["상품명"] : item.name
                        });
                    });
                    if (boundType === "reservation")
                        setPackages(tmp);
                    else if (boundType === "ticket")
                        setTickets(tmp);
                    else
                        setShoppingCategories(tmp);
                })
                .catch(async (error) => await dialogService.handleAlert(error.message, { force: "error" }));
        }
    }, [boundType]);
    React.useEffect(() => {
        API.get(`/sites/camps/`)
            .then((response) => {
                const sites = (response.data || []).map((site) => ({
                    value: site.id,
                    label: site.name,
                }));
                setEventSites(sites);
                const defaultSite = sites.find((site) => site.value === SITE_ID);
                if (defaultSite) {
                    setSelectedBookSites([defaultSite]);
                }
            })
            .catch(async (error) => await dialogService.handleAlert(error.message, { force: "error" }));
    }, []);
    const resetBookRuleForm = () => {
        setEditingBookRuleId(null);
        setBookStartDate(new Date());
        setBookEndDate(new Date());
        setBookState("노출중");
        setBookStock(1);
        setBookType("event");
        setBookUsageAmount(0);
        setBookUsagePeriod(30);
        setSelectedBookSites([currentBookSiteOption]);
    };
    const fetchCouponBookRules = React.useCallback(async () => {
        if (!canManageBookRules) {
            setCouponBookRules([]);
            return;
        }
        setBookRuleLoading(true);
        try {
            const response = await couponService.listCouponBookRules();
            const rules = (response.data || []).filter((rule) => rule.coupon_product?.id === couponId);
            setCouponBookRules(rules);
        }
        catch (error) {
            await dialogService.handleAlert(error.message, { force: "error" });
        }
        finally {
            setBookRuleLoading(false);
        }
    }, [canManageBookRules, couponId]);
    React.useEffect(() => {
        fetchCouponBookRules();
    }, [fetchCouponBookRules]);
    React.useEffect(() => {
        if (requestedTab === "book" && canManageBookRules) {
            setActiveTab("book");
        }
    }, [canManageBookRules, requestedTab]);
    React.useEffect(() => {
        if (!canManageBookRules && activeTab !== "basic") {
            setActiveTab("basic");
        }
    }, [activeTab, canManageBookRules]);
    const handleEditBookRule = (rule) => {
        setEditingBookRuleId(rule.id);
        setBookStartDate(rule.start_date);
        setBookEndDate(rule.end_date);
        setBookState(rule.state);
        setBookStock(rule.stock);
        setBookType("event");
        setBookUsageAmount(0);
        setBookUsagePeriod(30);
        setSelectedBookSites([currentBookSiteOption]);
    };
    const discardBookRuleForm = () => {
        setBookRuleModalOpen(false);
        resetBookRuleForm();
        setHasUnsavedBookRuleChanges(false);
    };
    const confirmBookRuleClose = async () => {
        if (hasUnsavedBookRuleChanges && !await dialogService.confirm(DEFAULT_UNSAVED_CHANGES_MESSAGE))
            return;
        discardBookRuleForm();
    };
    const openCreateBookRuleModal = () => {
        resetBookRuleForm();
        setHasUnsavedBookRuleChanges(false);
        setBookRuleModalOpen(true);
    };
    const openEditBookRuleModal = (rule) => {
        handleEditBookRule(rule);
        setHasUnsavedBookRuleChanges(false);
        setBookRuleModalOpen(true);
    };
    const openCouponBookDownloadPage = (ruleId: number) => {
        window.open(`${webBaseUrl}/event-coupon/${ruleId}`, "_blank", "noopener,noreferrer");
    };
    const saveBookRule = async () => {
        if (!canManageBookRules) {
            await dialogService.handleAlert("상품 저장 후 규칙을 설정할 수 있습니다.");
            return;
        }
        if (!bookStartDate || !bookEndDate) {
            await dialogService.handleAlert("시작일/종료일을 입력해주세요.");
            return;
        }
        const payload = {
            coupon_product: couponId,
            start_date: moment(new Date(bookStartDate as any)).format("YYYY-MM-DD"),
            end_date: moment(new Date(bookEndDate as any)).format("YYYY-MM-DD"),
            state: bookState,
            stock: Number(bookStock),
            type: "event",
            usage_amount: 0,
            usage_period_day: 0,
            target_sites: [currentBookSiteOption.value],
        };
        try {
            const successMessage = editingBookRuleId ? "할인쿠폰북 규칙이 수정되었습니다." : "할인쿠폰북 규칙이 생성되었습니다.";
            if (editingBookRuleId) {
                await couponService.updateCouponBookRule(editingBookRuleId, payload);
            }
            else {
                await couponService.createCouponBookRule(payload);
            }
            setHasUnsavedBookRuleChanges(false);
            await dialogService.handleAlert(successMessage);
            discardBookRuleForm();
            await fetchCouponBookRules();
        }
        catch (error) {
            await dialogService.handleAlert(error.message, { force: "error" });
        }
    };
    const deleteBookRule = async (ruleId: number) => {
        if (!await dialogService.confirm("해당 할인쿠폰북 규칙을 삭제하시겠습니까?"))
            return;
        try {
            await couponService.deleteCouponBookRule(ruleId);
            await dialogService.handleAlert("할인쿠폰북 규칙이 삭제되었습니다.");
            if (editingBookRuleId === ruleId) {
                discardBookRuleForm();
            }
            await fetchCouponBookRules();
        }
        catch (error) {
            await dialogService.handleAlert(error.message, { force: "error" });
        }
    };
    const fillStates = (data, copyMode = false) => {
        setTitle(copyMode ? data["title"] + " (복사)" : data["title"]);
        setDescript(data["descript"]);
        setCouponState(data["state"]);
        setBoundType(data["bound_type"]);
        setMinAmount(data["min_purchase"]);
        setType(data["discount_type"]);
        setAmount(data["discount_type"] === "price" ? data["discount_amount"] : data["discount_rate"]);
        setMaxAmount(data["max_discount"]);
        if (!copyMode) {
            setPrevImage(data["image"]);
        }
        const [_period, _unit] = convertPeriod(data["period_sec"]);
        setPeriod(_period);
        setUnit(_unit);
        setExpireDate(data["expire_date"]);
        if (data["expire_date"])
            setIsDate(true);
        else
            setIsDate(false);
        if (data["bound_type"] === "reservation") {
            setSelectedPackageItems(data["packages"]?.map((item) => {
                return { value: item.id, label: item.name };
            }));
            setReservStartDate(data["use_start_date"]);
            setReservEndDate(data["use_end_date"]);
            setReservUseMon(data["use_mon"]);
            setReservUseTue(data["use_tue"]);
            setReservUseWed(data["use_wed"]);
            setReservUseThu(data["use_thu"]);
            setReservUseFri(data["use_fri"]);
            setReservUseSat(data["use_sat"]);
            setReservUseSun(data["use_sun"]);
            setReservUseHoliday(data["use_holiday"]);
        }
        else if (data["bound_type"] === "ticket") {
            setSelectedTicketItems(data["tickets"].map((item) => ({ value: item.id, label: item.name })));
        }
        else if (data["bound_type"] === "shopping") {
            setSelectedShoppingCategories(data["shopping_categories"].map((item) => ({ value: item.id, label: item.name })));
        }
    };
    const sendData = async () => {
        const data = await checkData(true);
        if (data === null)
            return;
        let createdId = null;
        API.post('/coupon/products/', data)
            .then((response) => {
                createdId = response.data?.id;
                if (image) {
                    return handleUploadImage(createdId, image, title, descript);
                }
            })
            .then(async () => {
                setHasUnsavedChanges(false);
                await dialogService.handleAlert("쿠폰이 등록되었습니다.");
                if (createdId) {
                    navigate(`/coupon-form/${createdId}`);
                }
            })
            .catch(async (error) => await dialogService.handleAlert(error.message, { force: "error" }));
    };
    const updateData = async () => {
        const data = await checkData(false);
        if (data === null)
            return;
        API.put(`/coupon/products/${id}/`, data)
            .then((response) => {
                if (image) {
                    return handleUploadImage(id, image, title, descript);
                }
            })
            .then(async () => {
                setHasUnsavedChanges(false);
                await dialogService.handleAlert("쿠폰이 수정되었습니다.");
                navigate('/coupon-list');
            })
            .catch(async (error) => await dialogService.handleAlert(error.message, { force: "error" }));
    };
    const handleUploadImage = (id, image, title, descript) => {
        const formData = new FormData();
        formData.append("title", title);
        formData.append("descript", descript);
        formData.append("image", image);
        return API.patch(`/coupon/products/${id}/`, formData, {
            headers: { "Content-Type": "multipart/form-data" }
        });
    };
    const getPeriod = (period, unit) => {
        if (isDate) {
            return null;
        }
        return toCouponPeriodSeconds(period, unit as CouponPeriodUnit);
    };
    const convertPeriod = (periodSec) => {
        let period = null;
        let unit = null;
        if (!isDate) {
            for (let key in COUPON_PERIOD_SECONDS) {
                if (periodSec % COUPON_PERIOD_SECONDS[key] === 0) {
                    period = periodSec / COUPON_PERIOD_SECONDS[key];
                    unit = key;
                    break;
                }
            }
        }
        return [period, unit];
    };
    const checkData = async (isNew = false) => {
        const missingRequiredFields = findMissingRequiredFields([
            { label: "쿠폰명", value: title, elementId: "title" },
            { label: "유효기간", value: isDate ? expireDate : period, elementId: isDate ? "expireDateField" : "period" },
            { label: "할인금액", value: amount, elementId: "amount" },
            ...(type === "percentage" ? [{ label: "할인가능 최대금액", value: maxAmount, elementId: "mostAmount" }] : []),
            ...(boundType === "reservation" ? [{ label: "할인대상 예약상품", value: selectedPackageItems, elementId: "packageTargetField" }] : []),
            ...(boundType === "ticket" ? [{ label: "할인대상 티켓", value: selectedTicketItems, elementId: "ticketTargetField" }] : []),
            ...(boundType === "shopping" ? [{ label: "할인대상 쇼핑몰 상품", value: selectedShoppingCategories, elementId: "shoppingTargetField" }] : []),
        ]);
        if (missingRequiredFields.length > 0) {
            await dialogService.handleAlert(formatRequiredMessage(missingRequiredFields));
            focusFirstMissingField(missingRequiredFields);
            return null;
        }
        let periodSec = getPeriod(period, unit);
        if (!isDate && periodSec === null) {
            await dialogService.handleAlert(getCouponPeriodLimitMessage(unit as CouponPeriodUnit));
            focusFirstMissingField([{ label: "유효기간", value: period, elementId: "period" }]);
            return null;
        }
        let data = {
            "title": title,
            "descript": descript,
            "state": couponState,
            "bound_type": boundType,
            "min_purchase": minAmount,
            "discount_type": type,
            "discount_amount": type === "price" ? amount : 0,
            "discount_rate": type === "percentage" ? amount : 0,
            "max_discount": type === "percentage" ? maxAmount : 0,
            "period_sec": !isDate ? periodSec : undefined,
            "expire_date": isDate && expireDate ? moment(new Date(expireDate)).format('YYYY-MM-DD') : undefined,
        };
        if (isNew) {
            data["sites"] = [SITE_ID];
            data["useable_quantity"] = 0;
        }
        if (boundType === "reservation") {
            data["packages"] = selectedPackageItems.map((item) => (item.value));
            data["use_start_date"] = reservStartDate ? moment(new Date(reservStartDate)).format('YYYY-MM-DD') : null;
            data["use_end_date"] = reservEndDate ? moment(new Date(reservEndDate)).format('YYYY-MM-DD') : null;
            data["use_mon"] = reservUseMon;
            data["use_tue"] = reservUseTue;
            data["use_wed"] = reservUseWed;
            data["use_thu"] = reservUseThu;
            data["use_fri"] = reservUseFri;
            data["use_sat"] = reservUseSat;
            data["use_sun"] = reservUseSun;
            data["use_holiday"] = reservUseHoliday;
        }
        else if (boundType === "ticket") {
            data["tickets"] = selectedTicketItems.map((item) => (item.value));
        }
        else if (boundType === "shopping") {
            data["shopping_categories"] = selectedShoppingCategories.map((item) => (item.value));
        }
        return data;
    };
    return (<React.Fragment>
        <div className="page-content">
            <div className="container-fluid">
                <BreadCrumb title="쿠폰 등록 및 수정" pageTitle="쿠폰" />

                <div className="flex flex-wrap -mx-3 g-4 mb-3">
                    <div className="col-sm-auto px-3">
                        <div>
                            <h4 className="card-title mb-0 flex-grow-1">등록 및 수정</h4>
                        </div>
                    </div>
                    <div className="col-sm-3 ms-auto px-3">
                        <div className="d-flex justify-content-sm-end gap-2">
                            {(Number(id) !== 0 && !isCopyMode) ?
                                <Button onClick={updateData} id="create-btn" color="success" className="add-btn me-1">
                                    Update
                                </Button> :
                                <Button onClick={sendData} id="update-btn" color="success" className="add-btn me-1">
                                    Create
                                </Button>}
                            <Button onClick={async () => {
                                if (!await confirmDiscardChanges())
                                    return;
                                navigate(`/coupon-list`);
                            }} id="cancel-btn" color="danger" className="add-btn me-1">
                                Cancel
                            </Button>
                        </div>
                    </div>
                </div>

                {canManageBookRules ? (
                    <div className="flex flex-wrap -mx-3">
                        <div className="w-full xxl:w-full px-3">
                            <div className="card border-0 shadow-sm rounded-xl overflow-hidden">
                                <div className="card-body p-0">
                                    <Nav tabs className="nav-tabs-custom nav-success border-0 px-4">
                                        <NavItem>
                                            <NavLink className={cn("px-4 py-3 cursor-pointer font-medium border-b-2 transition-all", activeTab === "basic"
                                                ? "border-green-500 text-green-600 active"
                                                : "border-transparent text-gray-500 hover:text-gray-700")} onClick={() => setActiveTab("basic")}>
                                                기본정보
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink className={cn("px-4 py-3 cursor-pointer font-medium border-b-2 transition-all", activeTab === "book"
                                                ? "border-green-500 text-green-600 active"
                                                : "border-transparent text-gray-500 hover:text-gray-700")} onClick={() => setActiveTab("book")}>
                                                배포(쿠폰북)
                                            </NavLink>
                                        </NavItem>
                                    </Nav>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null}

                {activeTab === "basic" ? (
                    <>
                        <div className="flex flex-wrap -mx-3">
                            <div className="w-full xxl:w-full px-3">
                                <div className="card">
                                    <div className="card-body" onChangeCapture={markDirty} onInputCapture={markDirty}>
                                        <div className="live-preview">
                                            <div className="flex flex-wrap -mx-3">
                                                <div className="w-full md:w-6/12 px-3">
                                                    <div className="mb-3">
                                                        <label htmlFor="firstNameinput" className="form-label">쿠폰명</label>
                                                        <input type="text" className="form-control" placeholder="쿠폰명" id="title" value={title} onChange={(e) => (setTitle(e.target.value))} maxLength="100" />
                                                    </div>
                                                </div>
                                                <div className="w-full md:w-6/12 px-3">
                                                    <div className="mb-3">
                                                        <label htmlFor="ForminputState" className="form-label">쿠폰 상태</label>
                                                        <select value={couponState} onChange={(e) => (setCouponState(e.target.value))} id="ForminputState" className="form-select" data-choices data-choices-sorting="true">
                                                            <option key={0} value={"노출중"}>노출중</option>
                                                            <option key={1} value={"숨김"}>숨김</option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div className="w-full md:w-6/12 px-3">
                                                    <div className="mb-3">
                                                        <label htmlFor="ForminputBoundType" className="form-label">할인대상 범위</label>
                                                        <select value={boundType} onChange={(e) => (setBoundType(e.target.value))} id="ForminputBoundType" className="form-select" data-choices data-choices-sorting="true">
                                                            <option key={0} value={"reservation"}>예약</option>
                                                            <option key={1} value={"ticket"}>티켓</option>
                                                            <option key={2} value={"shopping"}>쇼핑몰</option>
                                                        </select>
                                                    </div>
                                                </div>

                                                {boundType === "reservation" ? <div className="w-full md:w-6/12 px-3">
                                                    <div className="mb-3" id="packageTargetField" tabIndex={-1}>
                                                        <label htmlFor="ForminputPackageItem" className="form-label">할인대상 예약상품</label>
                                                        <Select isMulti name="packages" options={packages} className="basic-multi-select" classNamePrefix="select" onChange={(val) => {
                                                            markDirty();
                                                            setSelectedPackageItems([...(val || [])]);
                                                        }} value={selectedPackageItems} />
                                                    </div>
                                                    <div className="mb-3">
                                                        <label className="form-check-label" htmlFor="reservStartDate">예약가능 시작일</label>
                                                        <CommonDatePicker value={reservStartDate} onChange={(value) => {
                                                            markDirty();
                                                            setReservStartDate(value);
                                                        }} className="form-control" options={{
                                                        }} />
                                                    </div>
                                                    <div className="mb-3">
                                                        <label className="form-check-label" htmlFor="reservEndDate">예약가능 종료일</label>
                                                        <CommonDatePicker value={reservEndDate} onChange={(value) => {
                                                            markDirty();
                                                            setReservEndDate(value);
                                                        }} className="form-control" options={{
                                                        }} />
                                                    </div>
                                                    <div className="mb-3">
                                                        <label className="form-check-label" htmlFor="">예약가능 요일</label><br />
                                                        <input style={{ marginLeft: 15 }} className="form-check-input" type="checkbox" id="reserv_use_mon" checked={reservUseMon} onChange={(e) => { setReservUseMon(e.target.checked); }} />
                                                        <label className="form-check-label" htmlFor="reserv_use_mon">&nbsp;월요일</label>
                                                        <input style={{ marginLeft: 15 }} className="form-check-input" type="checkbox" id="reserv_use_tue" checked={reservUseTue} onChange={(e) => { setReservUseTue(e.target.checked); }} />
                                                        <label className="form-check-label" htmlFor="reserv_use_tue">&nbsp;화요일</label>
                                                        <input style={{ marginLeft: 15 }} className="form-check-input" type="checkbox" id="reserv_use_wed" checked={reservUseWed} onChange={(e) => { setReservUseWed(e.target.checked); }} />
                                                        <label className="form-check-label" htmlFor="reserv_use_wed">&nbsp;수요일</label>
                                                        <input style={{ marginLeft: 15 }} className="form-check-input" type="checkbox" id="reserv_use_thu" checked={reservUseThu} onChange={(e) => { setReservUseThu(e.target.checked); }} />
                                                        <label className="form-check-label" htmlFor="reserv_use_thu">&nbsp;목요일</label>
                                                        <input style={{ marginLeft: 15 }} className="form-check-input" type="checkbox" id="reserv_use_fri" checked={reservUseFri} onChange={(e) => { setReservUseFri(e.target.checked); }} />
                                                        <label className="form-check-label" htmlFor="reserv_use_fri">&nbsp;금요일</label>
                                                        <input style={{ marginLeft: 15 }} className="form-check-input" type="checkbox" id="reserv_use_sat" checked={reservUseSat} onChange={(e) => { setReservUseSat(e.target.checked); }} />
                                                        <label className="form-check-label" htmlFor="reserv_use_sat">&nbsp;토요일</label>
                                                        <input style={{ marginLeft: 15 }} className="form-check-input" type="checkbox" id="reserv_use_sun" checked={reservUseSun} onChange={(e) => { setReservUseSun(e.target.checked); }} />
                                                        <label className="form-check-label" htmlFor="reserv_use_sun">&nbsp;일요일</label>
                                                        <input style={{ marginLeft: 15 }} className="form-check-input" type="checkbox" id="reserv_use_holiday" checked={reservUseHoliday} onChange={(e) => { setReservUseHoliday(e.target.checked); }} />
                                                        <label className="form-check-label" htmlFor="reserv_use_holiday">&nbsp;공휴일</label>
                                                    </div>
                                                </div> : null}
                                                {boundType === "ticket" ? <div className="w-full md:w-6/12 px-3">
                                                    <div className="mb-3" id="ticketTargetField" tabIndex={-1}>
                                                        <label htmlFor="ForminputTicketItem" className="form-label">할인대상 티켓</label>
                                                        <Select isMulti name="tickets" options={tickets} className="basic-multi-select" classNamePrefix="select" onChange={(val) => {
                                                            markDirty();
                                                            setSelectedTicketItems([...(val || [])]);
                                                        }} value={selectedTicketItems} />
                                                    </div>
                                                </div> : null}
                                                {boundType === "shopping" ? <div className="w-full md:w-6/12 px-3">
                                                    <div className="mb-3" id="shoppingTargetField" tabIndex={-1}>
                                                        <label htmlFor="ForminputShoppingItem" className="form-label">할인대상 쇼핑몰 상품</label>
                                                        <Select isMulti name="shoppings" options={shoppingCategories} className="basic-multi-select" classNamePrefix="select" onChange={(value) => {
                                                            markDirty();
                                                            setSelectedShoppingCategories(value);
                                                        }} value={selectedShoppingCategories} />
                                                    </div>
                                                </div> : null}

                                                <div className="w-full md:w-6/12 px-3">
                                                    <div className="mb-3">
                                                        <label htmlFor="leastAmountinput" className="form-label">사용가능 최소금액</label>
                                                        <input type="number" className="form-control" placeholder="~원 이상 구매시 사용가능" id="leastAmount" value={minAmount} onChange={(e) => { setMinAmount(Number(e.target.value) < 0 || !e.target.value ? "" : e.target.value); }} min="0" />
                                                    </div>
                                                </div>

                                                <div className="w-full md:w-6/12 px-3">
                                                    <div className="flex flex-wrap -mx-3 mb-3">
                                                        <div className="w-full md:w-3/12 xs:w-6/12 px-3">
                                                            <label htmlFor="ForminputState" className="form-label">할인</label>
                                                            <select value={type} onChange={(e) => (setType(e.target.value))} id="ForminputState" className="form-select" data-choices data-choices-sorting="true">
                                                                <option key="price" value="price">원</option>
                                                                <option key="percentage" value="percentage">%</option>
                                                            </select>
                                                        </div>
                                                        <div className="w-full md:w-9/12 xs:w-6/12 px-3">
                                                            <label htmlFor="ForminputState" className="form-label" style={{ color: "#00ff0000" }}>할인</label>
                                                            <input type="number" className="form-control" placeholder="할인" id="amount" value={amount} onChange={(e) => (setAmount(Number(e.target.value) < 0 || !e.target.value ? "" : e.target.value))} min="0" />
                                                        </div>
                                                    </div>
                                                    {type === "percentage" ? <div className="mb-3">
                                                        <label htmlFor="mostAmountinput" className="form-label">할인가능 최대금액</label>
                                                        <input type="number" className="form-control" placeholder="~ 원까지 할인가능" id="mostAmount" value={maxAmount} onChange={(e) => { setMaxAmount(e.target.value < 0 || !e.target.value ? "" : e.target.value); }} min="0" />
                                                    </div> : null}
                                                </div>
                                                <div className="w-full md:w-6/12 px-3" style={{ overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                                                    <div className="">
                                                        <label htmlFor="ForminputState" className="form-label">
                                                            유효기간
                                                        </label>
                                                        <label htmlFor="ForminputState" className="form-label">
                                                            <input style={{ marginLeft: 15 }} className="form-check-input" type="checkbox" id="isDate" checked={isDate} onChange={(e) => { setIsDate(e.target.checked); }} />
                                                            <label className="form-check-label" htmlFor="isDate">
                                                                날짜지정
                                                            </label>
                                                        </label>
                                                    </div>
                                                    <div className="flex flex-wrap -mx-3 mb-3">
                                                        <div className="w-full md:w-3/12 xs:w-6/12 px-3" style={{ display: `${(isDate) ? "none" : "block"}` }}>
                                                            <select value={unit} onChange={(e) => (setUnit(e.target.value))} id="ForminputState" className="form-select" data-choices data-choices-sorting="true">
                                                                <option key="years" value="years">연</option>
                                                                <option key="months" value="months">월</option>
                                                                <option key="days" value="days">일</option>
                                                            </select>
                                                        </div>
                                                        <div className={`w-full ${isDate ? 'md:w-full' : 'md:w-9/12'} ${isDate ? 'xs:w-full' : 'xs:w-6/12'} px-3`}>
                                                            {(isDate) ?
                                                                <CommonDatePicker value={expireDate} onChange={(value) => {
                                                                    markDirty();
                                                                    setExpireDate(value);
                                                                }} id="expireDateField" className="form-control" options={{
                                                                }} /> :
                                                                <input type="number" className="form-control" placeholder="유효기간" id="period" value={period} onChange={(e) => (setPeriod(e.target.value < 0 || !e.target.value ? "" : e.target.value))} min="0" />}
                                                        </div>
                                                        {!isDate ? (
                                                            <p className="w-full px-3 mt-2 mb-0 text-muted" style={{ fontSize: "12px", whiteSpace: "normal" }}>
                                                                연/월/일 입력은 쿠폰을 받은 날부터 계산되는 상대 기간입니다. 예: 1년 = 쿠폰 수신 후 1년 뒤 만료
                                                            </p>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="w-full md:w-6/12 px-3">
                                                    <div className="mb-3">
                                                        <label htmlFor="formFile" className="form-label">쿠폰이미지</label>
                                                        <input className="form-control" type="file" id="formFile" accept="image/jpg, image/jpeg, image/png" ref={fileInputRef} onChange={handleImageFiles} />
                                                    </div>
                                                    {prevImage && !image ? <div className="mb-3">
                                                        <img src={prevImage} alt="이미지" style={{ width: "120px", height: "auto" }} />
                                                    </div> : null}
                                                </div>
                                                <div className="w-full md:w-6/12 px-3">
                                                    <div className="mb-3">
                                                        <p>사용가능 결제수단: 카드, 간편결제, 실시간 계좌이체 등 (토스 지원 결제수단) </p>
                                                        <p>쿠폰취소 메소드: 개별 취소의 경우 취소 안됨.(예: 3개 구매 건 중 1개만 취소) 전체 취소 경우만 취소 가능</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-wrap -mx-3">
                            <div className="w-full xxl:w-full px-3">
                                <div className="card">
                                    <div className="card-header">
                                        <h4 className="card-title mb-0">상세정보</h4>
                                    </div>
                                    <div className="card-body">
                                        <div className="snow-editor" style={{ height: 300 }}>
                                            <MyEditor value={descript} onChange={(value) => {
                                                markDirty();
                                                setDescript(value);
                                            }} uid={1} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                ) : null}

                {canManageBookRules && activeTab === "book" ? (
                    <>
                        <div className="flex flex-wrap -mx-3">
                            <div className="w-full xxl:w-full px-3">
                                <div className="card border-0 shadow-sm rounded-xl overflow-hidden">
                                    <div className="card-header bg-white border-b border-gray-100 px-6 py-5 flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
                                        <div>
                                            <h4 className="mb-1 text-lg font-semibold text-gray-900">할인쿠폰북 규칙 (서브리스트)</h4>
                                            <span className='text-sm text-gray-500'>등록 시 쿠폰북 다운로드 페이지에서 다운로드 가능합니다.</span>
                                        </div>
                                        <Button color="success" className="rounded-lg px-5 h-10 text-sm font-semibold" onClick={openCreateBookRuleModal}>
                                            규칙 생성
                                        </Button>
                                    </div>
                                    <div className="card-body p-0">
                                        <div className="table-responsive">
                                            <table className="table table-bordered align-middle mb-0">
                                                <thead>
                                                    <tr>
                                                        <th className="bg-slate-50 px-4 py-3 text-left text-sm font-semibold text-slate-700 whitespace-nowrap">ID</th>
                                                        <th className="bg-slate-50 px-4 py-3 text-left text-sm font-semibold text-slate-700 whitespace-nowrap">기간</th>
                                                        <th className="bg-slate-50 px-4 py-3 text-left text-sm font-semibold text-slate-700 whitespace-nowrap">상태</th>
                                                        <th className="bg-slate-50 px-4 py-3 text-left text-sm font-semibold text-slate-700 whitespace-nowrap">타입</th>
                                                        <th className="bg-slate-50 px-4 py-3 text-left text-sm font-semibold text-slate-700 whitespace-nowrap">수량</th>
                                                        <th className="bg-slate-50 px-4 py-3 text-left text-sm font-semibold text-slate-700 whitespace-nowrap">대상 사이트</th>
                                                        <th className="bg-slate-50 px-4 py-3 text-left text-sm font-semibold text-slate-700 whitespace-nowrap">동작</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {bookRuleLoading ? (
                                                        <tr>
                                                            <td colSpan={7} className="text-center text-slate-500 py-8">로딩중...</td>
                                                        </tr>
                                                    ) : couponBookRules.length === 0 ? (
                                                        <tr>
                                                            <td colSpan={7} className="text-center text-slate-500 py-8">등록된 할인쿠폰북 규칙이 없습니다.</td>
                                                        </tr>
                                                    ) : (
                                                        couponBookRules.map((rule) => (
                                                            <tr key={rule.id}>
                                                                <td className="px-4 py-3 text-sm text-slate-700">{rule.id}</td>
                                                                <td className="px-4 py-3 text-sm text-slate-700 whitespace-nowrap">{rule.start_date} ~ {rule.end_date}</td>
                                                                <td className="px-4 py-3 text-sm text-slate-700">{rule.state}</td>
                                                                <td className="px-4 py-3 text-sm text-slate-700">{rule.type}</td>
                                                                <td className="px-4 py-3 text-sm text-slate-700">{rule.stock}</td>
                                                                <td className="px-4 py-3 text-sm text-slate-700">{(rule.target_sites || []).map((site) => site.name).join(", ") || "-"}</td>
                                                                <td className="px-4 py-3 text-sm text-slate-700">
                                                                    <div className="flex flex-wrap gap-2 min-w-max">
                                                                        <Button color="info" size="sm" className="rounded-lg px-3" onClick={() => openCouponBookDownloadPage(rule.id)}>
                                                                            다운로드 링크
                                                                        </Button>
                                                                        <Button color="success" size="sm" className="rounded-lg px-3" onClick={() => openEditBookRuleModal(rule)}>
                                                                            수정
                                                                        </Button>
                                                                        <Button color="danger" size="sm" className="rounded-lg px-3" onClick={() => deleteBookRule(rule.id)}>
                                                                            삭제
                                                                        </Button>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <Modal isOpen={bookRuleModalOpen} onClose={() => { void confirmBookRuleClose(); }} size="5xl" variant="dialog" centered>
                            <ModalHeader toggle={() => { void confirmBookRuleClose(); }}>
                                {editingBookRuleId ? "할인쿠폰북 규칙 수정" : "할인쿠폰북 규칙 생성"}
                            </ModalHeader>
                            <ModalBody>
                                <div className="flex flex-wrap -mx-3" onChangeCapture={markBookRuleDirty} onInputCapture={markBookRuleDirty}>
                                    <div className="w-full md:w-4/12 px-3">
                                        <div className="mb-3">
                                            <label className="form-label">시작일</label>
                                            <CommonDatePicker value={bookStartDate} onChange={(value) => {
                                                markBookRuleDirty();
                                                setBookStartDate(value);
                                            }} className="form-control" options={{
                                            }} />
                                        </div>
                                    </div>
                                    <div className="w-full md:w-4/12 px-3">
                                        <div className="mb-3">
                                            <label className="form-label">종료일</label>
                                            <CommonDatePicker value={bookEndDate} onChange={(value) => {
                                                markBookRuleDirty();
                                                setBookEndDate(value);
                                            }} className="form-control" options={{
                                            }} />
                                        </div>
                                    </div>
                                    <div className="w-full md:w-4/12 px-3">
                                        <div className="mb-3">
                                            <label className="form-label">상태</label>
                                            <select value={bookState} onChange={(e) => setBookState(e.target.value)} className="form-select">
                                                <option value="노출중">노출중</option>
                                                <option value="숨김">숨김</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="w-full md:w-4/12 px-3">
                                        <div className="mb-3">
                                            <label className="form-label">수량</label>
                                            <input type="number" className="form-control" value={bookStock} min={1} onChange={(e) => setBookStock(Number(e.target.value) || 1)} />
                                        </div>
                                    </div>
                                    <div className="w-full md:w-4/12 px-3">
                                        <div className="mb-3">
                                            <label className="form-label">타입</label>
                                            <select value={bookType} onChange={(e) => setBookType(e.target.value)} className="form-select" disabled>
                                                <option value="event">이벤트</option>
                                                <option value="new_join">신규 회원가입</option>
                                                <option value="membership">맴버십 회원</option>
                                                <option value="usage_amount">기간 사용금액</option>
                                            </select>
                                            <p className="mt-2 text-xs text-slate-500">현재 사이트 이벤트 배포로 고정됩니다.</p>
                                        </div>
                                    </div>
                                    <div className="w-full md:w-4/12 px-3">
                                        <div className="mb-3">
                                            <label className="form-label">대상 사이트</label>
                                            <Select isMulti isDisabled name="bookRuleSites" options={eventSites} className="basic-select" classNamePrefix="select" value={selectedBookSites} />
                                        </div>
                                    </div>
                                </div>
                                <div className="flex justify-end gap-2">
                                    <Button color="light" onClick={() => { void confirmBookRuleClose(); }}>취소</Button>
                                    <Button color="success" onClick={saveBookRule}>
                                        {editingBookRuleId ? "수정" : "생성"}
                                    </Button>
                                </div>
                            </ModalBody>
                        </Modal>
                    </>
                ) : null}
            </div>
        </div>
    </React.Fragment>);
};
export default CouponForm;
